/*
 * Seo.jsx — Lightweight per-route SEO. Updates document.title, meta description
 * and the canonical link on mount (Googlebot executes JS, so it picks these up).
 * Kept dependency-free to avoid react-helmet peer issues on React 19.
 */
import { useEffect } from "react";

export const Seo = ({ title, description, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    // Google Search Console ownership verification (value comes from frontend .env)
    setMeta("google-site-verification", process.env.REACT_APP_GOOGLE_SITE_VERIFICATION);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);

  return null;
};
